import { render, staticRenderFns } from "./HistoryPrescriptionComparison.vue?vue&type=template&id=d0c3d3ce&"
import script from "./HistoryPrescriptionComparison.vue?vue&type=script&lang=js&"
export * from "./HistoryPrescriptionComparison.vue?vue&type=script&lang=js&"
import style0 from "./HistoryPrescriptionComparison.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports